// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"cc7c5ec0","654":"3744e201","977":"645981d4"}[chunkId] + ".chunk.js";
};